import { useMemo } from "react";

import { InfoOutlinedIcon } from "icons";
import { colors } from "theme/palette";
import { areInstructionsEmpty } from "utils/common";

import SanitizeHtml from "components/SanitizeHtml";
import Stack from "components/Stack";
import Text from "components/Text";

export interface IInstructions {
  internalInstructions: string | null | undefined;
  externalInstructions: string | null | undefined;
}

const Instructions = ({
  internalInstructions,
  externalInstructions,
}: IInstructions) => {
  const showExternalInstructions = useMemo(
    () => !areInstructionsEmpty({ instructions: externalInstructions }),
    [externalInstructions]
  );

  const showInternalInstructions = useMemo(
    () => !areInstructionsEmpty({ instructions: internalInstructions }),
    [internalInstructions]
  );

  return showInternalInstructions || showExternalInstructions ? (
    <Stack
      direction="column"
      marginTop={1.5}
      marginLeft={4}
      marginBottom={1}
      gap={1.5}
    >
      {showInternalInstructions && (
        <Stack direction="column" spacing={1}>
          <Stack alignItems="center" direction="row" spacing={1}>
            <InfoOutlinedIcon
              sx={{
                width: "16px",
                height: "16px",
                color: colors.pink100,
              }}
            />
            <Text variant="label" fontWeight={500} color={colors.pink100}>
              reviewer instructions
            </Text>
          </Stack>
          <Text variant="text4" sx={{ color: colors.gray80 }}>
            <SanitizeHtml html={internalInstructions || ""} />
          </Text>
        </Stack>
      )}

      {showExternalInstructions && (
        <Stack direction="column" spacing={1}>
          <Stack alignItems="center" direction="row" spacing={1}>
            <InfoOutlinedIcon
              sx={{
                width: "16px",
                height: "16px",
                color: colors.blue100,
              }}
            />
            <Text variant="label" color={colors.blue100}>
              {showInternalInstructions ? "public " : ""}instructions
            </Text>
          </Stack>
          <Text variant="text4" sx={{ color: colors.gray80 }}>
            <SanitizeHtml html={externalInstructions || ""} />
          </Text>
        </Stack>
      )}
    </Stack>
  ) : null;
};

export default Instructions;
